import React from 'react';
import '../styles/ClientLogosMain.css';
import rawClientData from '../assets/rawClientData.json';

const loadLogo = (shortName) => {
  try {
    return require(`../assets/logos/${shortName}.png`);
  } catch {
    return null;
  }
};

const clientData = Object.fromEntries(
  Object.entries(rawClientData).map(([category, clients]) => [
    category,
    clients.map((client) => ({
      ...client,
      logo: loadLogo(client.shortName)
    }))
  ])
);

const ClientLogosMain = ({ category }) => {
  const clients = category ? clientData[category] : Object.values(clientData).flat();

  const uniqueSortedClients = Array.from(
    new Map(clients.map((c) => [c.shortName, c])).values()
  ).sort((a, b) => a.shortName.localeCompare(b.shortName));

  return (
    <div className="client-logos-compact-section">
      <div className="container">
        <div className="client-logos-compact-grid">
          {uniqueSortedClients.map((client, index) => (
            <div className="client-logo-compact-item" key={index}>
              {client.logo ? (
                <img
                  src={client.logo}
                  alt={client.shortName}
                  className="client-logo-compact-img"
                  loading="eager"
                />
              ) : (
                <span className="client-logo-compact-text">{client.shortName}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


export default ClientLogosMain;